// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAp9NraeSyYXH4Rmoh-HcyqQkDncoICqzk",
  authDomain: "twizz-f6d50.firebaseapp.com",
  projectId: "twizz-f6d50",
  storageBucket: "twizz-f6d50.firebasestorage.app",
  messagingSenderId: "1020829184207",
  appId: "1:1020829184207:web:ea9323dce5ef203e3687ba",
  measurementId: "G-T3YTD1T0ZN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
// Ensure auth persists across reloads/tabs
setPersistence(auth, browserLocalPersistence).catch(() => {});
export const storage = getStorage(app);
export const db = getFirestore(app);
export default app; 